import { MenuItem as MUIMenuItem, styled } from "@mui/material";
import { withStyles } from "@mui/styles";
import { FontSize, getFontStyle } from "../materialInput/Fonts";
import { C_DROPDOWN_HOVER, C_ON_SURFACE, C_OUTLINE_VARIANT, C_PRIMARY } from "../icon/Colors";

/*
  @deprecated - use the mui MenuItem instead
*/
export const MenuItem = withStyles((theme) => ({
  root: {
    ...getFontStyle(FontSize.TitleMedium),
    padding: "10px 20px",
    color: `${C_ON_SURFACE} !important`,
    "&:hover": {
      backgroundColor: `${C_DROPDOWN_HOVER} !important`,
    },
  },
  selected: {
    color: C_PRIMARY,
    backgroundColor: "transparent !important",
  },
}))(MUIMenuItem);

export const MenuItemNavigation = styled(MUIMenuItem)({
  ...getFontStyle(FontSize.TitleSmall),
  color: C_ON_SURFACE,
  "&:hover": {
    color: C_ON_SURFACE,
    backgroundColor: C_DROPDOWN_HOVER,
  },
  width: 220,
  "&.Mui-selected": {
    color: C_PRIMARY,
    backgroundColor: "transparent !important",
  },
});

export const StaticMenuItem = styled("div")({
  ...getFontStyle(FontSize.TitleMedium),
  padding: "10px 20px",
  color: C_ON_SURFACE,
});

interface MenuSpacerProps {
  fullwidth?: boolean;
}
export const MenuSpacer = styled("hr")(({ fullwidth }: MenuSpacerProps) => ({
  margin: fullwidth ? "0" : "0 20px",
  borderTop: `1px solid ${C_OUTLINE_VARIANT}`,
}));
